















































































import {
  Component,
  Mixins,
} from 'vue-property-decorator';

import bButton from 'bootstrap-vue/es/components/button/button';

import PalettePanel from './PalettePanel';

// See https://stackoverflow.com/a/21015393.
function getTextWidth(text: string): number {
  // Re-use canvas object for better performance.
  let canvasContext: CanvasRenderingContext2D  = (getTextWidth as any).canvasContext;
  if (!canvasContext) {
    canvasContext = document.createElement('canvas').getContext('2d')!;
    // See https://stackoverflow.com/a/7444724.
    const fontFamily = window.getComputedStyle(document.body).getPropertyValue('font-family');
    canvasContext.font = '16px ' + fontFamily;
    (getTextWidth as any).canvasContext = canvasContext;
  }
  return canvasContext!.measureText(text).width;
}

@Component({
  components: {
    bButton,
  },
})
export default class ButtonPalettePanel extends Mixins(PalettePanel) {
  public readonly maxButtonWidth = 180;
  public buttonWidth = 0;

  get optionValues() {
    return this.value.option.values;
  }

  public created() {
    // Compute the button width. Find the button that has the longest text width.
    const optionValues = this.optionValues;
    for (let i = 0, e = optionValues.length; i < e; ++i) {
      const textWidth = getTextWidth(optionValues[i].value);
      if (textWidth >= this.maxButtonWidth) {
        this.buttonWidth = this.maxButtonWidth;
        break;
      } else if (textWidth > this.buttonWidth) {
        this.buttonWidth = textWidth;
      }
    }
  }
}

